import request from '@/utils/request'


// 查询师傅订单列表
export function listOrder(query) {
  return request({
    url: '/master/master-order/list',
    method: 'get',
    params: query
  })
}

// 查询师傅订单分页
export function pageOrder(query) {
  return request({
    url: '/master/master-order/page',
    method: 'get',
    params: query
  })
}

// 查询师傅订单详细
export function getOrder(data) {
  return request({
    url: '/master/master-order/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅订单
export function addOrder(data) {
  return request({
    url: '/master/master-order/add',
    method: 'post',
    data: data
  })
}

// 修改师傅订单
export function updateOrder(data) {
  return request({
    url: '/master/master-order/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅订单
export function delOrder(data) {
  return request({
    url: '/master/master-order/delete',
    method: 'post',
    data: data
  })
}
